export var Experiment = /*#__PURE__*/function (Experiment) {
  Experiment["MOCK_EXPERIMENT"] = "MOCK_EXPERIMENT";
  Experiment["IOSBRAINTREE"] = "IOSBRAINTREE";
  Experiment["UPGRADE_OFFER"] = "AB114";
  Experiment["MANAGE_ACCOUNT"] = "AB126";
  Experiment["FRIEND_REFERRAL_LINK"] = "AB130";
  Experiment["DROPIN_UI_APP"] = "AB132";
  Experiment["MANAGE_ACCOUNT_2"] = "AB136";
  Experiment["IAP_PAYMENT_OPTION"] = "AB137";
  Experiment["RENEWAL_EMAIL_INACTIVE_USER"] = "AB140";
  Experiment["SPLIT_HARDWARE_AND_PLAN"] = "AB149";
  Experiment["PRICING_UK_WEB"] = "AB145";
  Experiment["PRICING_US_WEB"] = "AB146";
  Experiment["THREEDS_VERIFICATION_AMOUNT"] = "AB150";
  Experiment["OURA_ROLLING_TRIAL"] = "AB153";
  Experiment["OURA_VS_THERMOMETER"] = "156";
  Experiment["BILLING_ADDRESS"] = "158";
  Experiment["PLANS_PAGE"] = "159";
  Experiment["PAYMENT_TEST"] = "160";
  Experiment["PRICING_TEST_UK_WEB"] = "170";
  Experiment["PRICING_TEST_US_WEB"] = "173";
  Experiment["NCWEB_HERO_TEST"] = "176";
  Experiment["PRICING_TEST_UK_APP"] = "177";
  Experiment["PRICING_TEST_US_APP"] = "178";
  Experiment["PAYMENTS_RELEASE_1"] = "179";
  Experiment["NEW_MEASURING_CARD_DESIGN"] = "180";
  Experiment["WEB_ONBOARDING"] = "181";
  Experiment["SIGNUP_LIGHT_DESIGN"] = "182";
  Experiment["SIGNUP_LIGHT_DESIGN_DISCOUNT_LABEL"] = "184";
  Experiment["ROLLING_TRIAL_7DAYS"] = "185";
  Experiment["ONBOARDING_LINK"] = "186";
  Experiment["CTA_BTN_TEXT"] = "187";
  Experiment["THERMO_PLACEMENT_TEST"] = "188";
  Experiment["NCWEB_HERO_REDESIGN"] = "189";
  Experiment["NCWEB_HP_REDESIGN"] = "190";
  Experiment["NCWEB_REDESIGN"] = "192";
  Experiment["NCWEB_CARD_ANIMATION"] = "193";
  Experiment["APP_QUIZ"] = "194";
  Experiment["NCWEB_POPUP_TEST"] = "195";
  Experiment["NCWEB_CARD_ANIMATION_V2"] = "196";
  Experiment["NCWEB_REDESIGN_V2"] = "197";
  Experiment["NCWEB_HERO_VIDEO"] = "198";
  Experiment["SIGNUP_PRE_SELECT"] = "199";
  Experiment["NCWEB_REDESIGN_V2_2"] = "200";
  Experiment["APP_QUIZ_V2_FULL"] = "201";
  Experiment["PLANS_PAGE_REVIEWS"] = "202";
  Experiment["HERO_CAROUSEL"] = "203";
  Experiment["INCORRECT_THERM_SHIPMENT"] = "204";
  Experiment["DEVICE_RECOMMENDATION"] = "205";
  Experiment["OURA_PAGE_ORDER"] = "206";
  Experiment["NCWEB_REDESIGN_V2_3"] = "207";
  Experiment["PRICING_TEST_US_APP_MONTHLY_SUB"] = "208";
  Experiment["WEB_QUIZ_INSIGHT_PAGES"] = "209";
  Experiment["US_SALES_TAX"] = "210";
  Experiment["FERTILITY_GOAL"] = "211";
  Experiment["CYCLEMATTERS_POPUP_TEST"] = "212";
  Experiment["DEVICE_RECOMMENDATION_V2"] = "213";
  Experiment["FERTILITY_GOAL_INFO_TEST"] = "214";
  Experiment["QUIZ_LOADING_SCREEN"] = "215";
  Experiment["FEEDBACK_FROM_TODAY"] = "216";
  Experiment["APPLE_PAY_ADDRESS"] = "217";
  Experiment["PLANS_PAGE_CARD_REDESIGN"] = "219";
  Experiment["HORMONES_TRANSITION_SCREEN"] = "221";
  Experiment["PAYMENTS_RELEASE_1_TRIAL"] = "222";
  Experiment["PAYMENTS_RELEASE_1_PRORATION"] = "223";
  Experiment["NCWEB_HOMEPAGE_REDESIGN"] = "224";
  Experiment["PRICING_TEST_US_MONTHLY"] = "225";
  Experiment["MOBILE_POPUP_TIMING"] = "226";
  Experiment["OURA_PAGE_REDESIGN"] = "227";
  Experiment["DEVICE_BACKDOOR"] = "228";
  Experiment["PAYMENTS_RELEASE_1_RETRY"] = "229";
  Experiment["QUIZ_SEX_QUESTIONS"] = "230";
  Experiment["REMOVE_DEMO_BUTTON"] = "231";
  Experiment["REMOVE_NAME_QUESTION"] = "232";
  Experiment["OURA_PAGE_REDESIGN_2"] = "233";
  Experiment["USER_REVIEWS_VS_APP_IMAGES"] = "234";
  Experiment["PAYMENTS_RELEASE_1_ACCOUNT_UPDATER"] = "235";
  Experiment["PAYMENTS_RELEASE_1_IMMEDIATE_RETRY"] = "236";
  Experiment["PAYMENTS_RELEASE_1_SCHEDULED_RETRY"] = "237";
  Experiment["QUIZ_SEX_QUESTIONS_2"] = "238";
  Experiment["RAF_REWARD"] = "239";
  Experiment["OURA_BUNDLE"] = "240";
  Experiment["NCWEB_NEW_HERO"] = "241";
  Experiment["NO_IAP_IN_EU"] = "242";
  Experiment["SIGNUP_QUIZ_UNDERSTAND_BODY_PAGE"] = "243";
  Experiment["SIGNUP_QUIZ_IN_OURA_FLOW"] = "244";
  Experiment["ANIMATE_PRIVACY_SCREEN"] = "245";
  Experiment["SHARED_ADDRESS_PAYMENT_PAGE"] = "246";
  Experiment["PLANS_PAGE_EXPAND"] = "247";
  Experiment["PAYMENTS_RELEASE_1_SCHEDULED_RETRY_2"] = "248";
  Experiment["SIDE_EFFECTS_NEW_SCREENS"] = "249";
  Experiment["VIDEO_INTRO_SCREEN"] = "250";
  Experiment["VERIFY_EMAIL_ON_WEB"] = "251";
  Experiment["T3_STOCK_DEPLETION"] = "252";
  Experiment["INCREASE_MONTHLY_PRICE"] = "253";
  Experiment["NCWEB_CM_CTA_TEXT"] = "254";
  Experiment["SIGNUP_DR_RECOMMENDS"] = "255";
  Experiment["EDITS_TEST_EXPERIMENT"] = "256";
  Experiment["PAYMENTS_RELEASE_1_TRIAL_2"] = "257";
  Experiment["STRIPE_POC_1"] = "258";
  Experiment["HARDWARE_RECOMMENDATIONS"] = "259";
  Experiment["FEATURE_FLAG_OURA_BG_SYNC"] = "260";
  Experiment["WEBSITE_CTA"] = "262";
  Experiment["HOW_IT_WORKS_TWEAK"] = "263";
  Experiment["MOVE_HARDWARE_CHOICE"] = "265";
  // 266 was taken for non dev created experiment that is setup from Admin3 only
  Experiment["REMOVE_QUIZ_INTRO_SCREEN"] = "267";
  Experiment["PLANS_PAGE_CARDS"] = "268";
  Experiment["REMOVE_NAME_QUESTION_WEB"] = "269";
  Experiment["MOVE_HARDWARE_CHOICE_2"] = "270";
  Experiment["WELCOME_SCREEN"] = "271";
  Experiment["PERIMENOPAUSE"] = "272";
  Experiment["INSURANCE_CAPTURE"] = "273";
  Experiment["CONTINGENT_PRICING"] = "274";
  Experiment["MOVE_GOAL_QUESTION"] = "275";
  // 276 Reassuring message
  Experiment["NCWEB_HERO_COPY"] = "277";
  Experiment["REMOVE_START_QUIZ_PAGE"] = "278";
  Experiment["HERO_VIDEO_ALTERNATIVE"] = "279";
  Experiment["NCWEB_NAVIGATION"] = "280";
  Experiment["COMPARE_BIRTH_CONTROL"] = "281";
  Experiment["LEAD_CAPTURE"] = "282";
  Experiment["CANCELLATION_FLOW_REIMBURSEMENT"] = "283";
  // 284 was taken for non dev created experiment that is setup from Admin3 only
  Experiment["LEAD_CAPTURE_APP"] = "285";
  Experiment["AGE_RANGE_VS_BIRTHDAY"] = "286";
  // 287 "Take the quiz copy on intro page CTA"
  Experiment["DEVICE_RECOMMENDATION_V3"] = "288";
  Experiment["BFCM_DESTINATION"] = "289";
  Experiment["FERTILITY_GOAL_V2"] = "290";
  Experiment["WELCOME_SCREEN_APP"] = "291";
  Experiment["REMOVE_OURA_DISCOUNT_MONTHLY_PLAN"] = "292";
  Experiment["INSIGHTS_BANNER"] = "293";
  Experiment["MEASURING_DEVICE_PAGE"] = "294";
  Experiment["INCREASE_YEARLY_PRICE"] = "295";
  Experiment["HCP_VISIBILITY"] = "296";
  // 294 Measuring Devices Page
  // 295 Yearly price increase
  // 296 HCP visibility
  Experiment["REMOVE_PAYMENT_TERM_CHECKBOX"] = "297";
  Experiment["PLANS_PAGE_APP"] = "298";
  Experiment["PLANS_PAGE_CARDS_V2"] = "299";
  Experiment["REVIEWS_PAGE_V2"] = "300";
  Experiment["FERTILITY_GOAL_APP"] = "303";
  Experiment["NCWEB_HOMEPAGE_HERO"] = "304";
  Experiment["NCWEB_JANUARY_BANNER"] = "305";
  Experiment["SIGNUP_QUIZ_BIRTHDAY_PAGE"] = "306";
  Experiment["APPLE_TAX"] = "307";
  Experiment["SIDE_EFFECTS"] = "308";
  Experiment["NCWEB_HOW_IT_WORKS_V2"] = "309";
  Experiment["CYCLE_INSIGHTS"] = "310";
  Experiment["REMOVE_AW_RECOMMENDATION"] = "311";
  Experiment["QUIZ_CHAPTER"] = "312";
  Experiment["GRADIENT_BUTTON"] = "313";
  Experiment["PERSONALIZED_QUIZ_RESULT"] = "314";
  Experiment["EDITS_TEST_EXPERIMENT_2"] = "315";
  Experiment["NCWEB_GRADIENT_BUTTON_HERO"] = "316";
  Experiment["REMOVE_DISCOUNT_PRE_SET_CART"] = "317";
  // PLANS_PAGE_USPS = '318',
  Experiment["JANUARY_BANNER_V2"] = "319";
  Experiment["SIGNUP_CHECKOUT_SCREEN"] = "320";
  Experiment["REVOKE_ACCESS_ROLLING_TRIAL_SUBSCRIPTION_CANCELLATION"] = "321";
  Experiment["OURA_SYNC_BEFORE_PAYMENT"] = "322";
  Experiment["OURA_NEW_FIRST_SCREEN"] = "325";
  // 323 - Pricing test US - web
  // 324 - Price test UK - web
  // 326 - Pricing test US - app
  // 327 - Pricing test UK - app
  Experiment["HARDWARE_PAGE_V3"] = "328";
  Experiment["SIGNUP_BIRTHDAY_ILLUSTRATIONS"] = "329";
  Experiment["QUIZ_TESTIMONIALS"] = "330";
  Experiment["QUIZ_BIRTH_CONTROL_INFO"] = "331";
  Experiment["TRACKERS_TODAY_EMPTY_STATE"] = "333";
  Experiment["HERO_COPY"] = "340";
  Experiment["NCWEB_RATINGS_IN_HERO"] = "341";
  Experiment["CYCLE_PHASE"] = "343";
  Experiment["DISCOUNTS_ON_CHECKOUT_SCREEN"] = "344";
  Experiment["NCWEB_HOME_HERO_VIDEO"] = "345";
  Experiment["NCWEB_HOME_HERO_GRADIENT_BUTTON"] = "346";
  Experiment["INCREASE_YEARLY_PRICE_EVEN_MORE"] = "347";
  Experiment["CYCLE_TRACKER_COMPARISON"] = "348";
  Experiment["NCWEB_NEW_NC_BIRTH_CONTROL_PAGE"] = "349";
  Experiment["NCWEB_HERO_BADGES"] = "350";
  Experiment["QUIZ_NEEDS_SECTION"] = "351";
  // 352 - USP copy alternative
  Experiment["NCWEB_LAST_CHANCE_BANNER"] = "353";
  Experiment["WS_OURA_NO_IGNORED_CONFIRMATION"] = "354";
  Experiment["WS_CYCLE_INSIGHTS"] = "355";
  Experiment["FERTILITY_CONCERNS"] = "356";
  Experiment["CM_MIDROLL_ADS"] = "357";
  Experiment["EARLY_LEAD_CAPTURE"] = "358";
  Experiment["PLANS_PAGE_CARDS_V3"] = "359";
  Experiment["FERTILITY_GOAL_APP_V2"] = "360";
  Experiment["CYCLEMATTERS_POPUP_TEST_2"] = "361";
  Experiment["OURA_SYNC_BEFORE_PAYMENT_V2"] = "362";
  Experiment["QUIZ_RESULTS_NEW_ILLUSTRATION"] = "363";
  Experiment["QUIZ_OURA_DISCOUNT_CHECKOUT"] = "364";
  Experiment["B1_IN_SIGNUP"] = "365";
  Experiment["QUIZ_OURA_FLOW_FIRST_SCREEN_ITERATION"] = "366";
  Experiment["BC_COMPARISON"] = "367";
  return Experiment;
}(Experiment || {});
export var BucketEditType = /*#__PURE__*/function (BucketEditType) {
  BucketEditType["Price"] = "Price";
  BucketEditType["Text"] = "Text";
  BucketEditType["TranslationKey"] = "TranslationKey";
  BucketEditType["Image"] = "Image";
  return BucketEditType;
}(BucketEditType || {});
export const NO_AB = 'removeAllAbTest';